module.exports = __webpack_public_path__ + "img/账单.09a555aa.svg";